module.exports = __webpack_public_path__ + "static/media/HeroSignUp.2a453dec.svg";